var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSubject = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#b4b4b4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H23V23H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.1,2H3.9A1.9,1.9,0,0,0,2.01,3.9L2,21l3.8-3.8H19.1A1.906,1.906,0,0,0,21,15.3V3.9A1.906,1.906,0,0,0,19.1,2Zm0,13.3H5.011l-.561.561-.551.551V3.9H19.1ZM5.8,11.5H7.7v1.9H5.8Zm0-2.85H7.7v1.9H5.8Zm0-2.85H7.7V7.7H5.8Zm3.8,5.7h4.75v1.9H9.6Zm0-2.85h7.6v1.9H9.6Zm0-2.85h7.6V7.7H9.6Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSubject, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/subject.84888677.svg";
export { ForwardRef as ReactComponent };